import { useEffect } from 'react';
import { setSettled, setClosed, useRequestsHandler } from '../redux/reducer/requestsHandler';
import { useDispatch } from 'react-redux';

export const useRequestHandlerSettled = () => {
  const dispatch = useDispatch();
  const requests = useRequestsHandler();

  useEffect(() => {
    for (const key in requests) {
      const request = requests[key];
      if (['fulfilled', 'rejected'].includes(request.status)) dispatch(setSettled(key));
      if (request.status === 'settled') dispatch(setClosed(key));
    }
  }, [requests]);
};
